export function validateEmail(email) 
{
    let emailValid = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    return emailValid;
}

export function validateFiscalCode(cf)
{
    var validi, i, s, set1, set2, setpari, setdisp;
    if( cf === '' )  return '';
    cf = cf.toUpperCase();
    if( cf.length !== 16 )
        return false;
    validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    for( i = 0; i < 16; i++ ){
        if( validi.indexOf( cf.charAt(i) ) === -1 )
            return false;
    }
    set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
    setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
    s = 0;
    for( i = 1; i <= 13; i += 2 )
        s += setpari.indexOf( set2.charAt( set1.indexOf( cf.charAt(i) )));
    for( i = 0; i <= 14; i += 2 )
        s += setdisp.indexOf( set2.charAt( set1.indexOf( cf.charAt(i) )));
    if( s%26 !== cf.charCodeAt(15)-'A'.charCodeAt(0) )
        return false;
    return true;
}

export function objectIsEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }  
    return true;
}

export function getAccademyYear(symbol){
    let now = new Date();
    let y1 = 0
    let y2 = 0
    //<7 significa prima di Agosto
    if(now.getMonth()<7){
      y2 = now.getFullYear()
      y1 = y2-1
    } else {
      y1 = now.getFullYear()
      y2 = y1+1
    }
    return y1+symbol+y2
  }

  export function OpenWindowWithPost(url, windowoption, name, params){
    var form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", url);
    form.setAttribute("target", name);
    for (var i in params){
      if (params.hasOwnProperty(i))
      {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = i;
        input.value = params[i];
        form.appendChild(input);
      }
    }
    document.body.appendChild(form);
    //note I am using a post.htm page since I did not want to make double request to the page
    //it might have some Page_Load call which might screw things up.
    window.open("post.htm", name, windowoption);
    form.submit();
    document.body.removeChild(form);
  }